import { BToast, BSpinner } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import util from '@/util'

export default {
  name: 'agenda',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapState('configuracoes', ['agenda', 'dadosRetorno', 'flagsDeControle']),
    ...mapGetters('configuracoes', ['possuiContaCaldav', 'sincronizacaoCaldavPermitida', 'sincronizacaoICalPermitida'])
  },

  data: () => {
    return {

    }
  },

  mounted () {
  },

  methods: {
    ...mapActions('configuracoes', ['ActionHabilitarOuDesabilitarCaldav']),
    habilitarOuDesabilitarCaldav () {
      this.ActionHabilitarOuDesabilitarCaldav()
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    copiarTexto (texto) {
      if (!texto) {
        util.criarAlertaToastDeErro(this, 'Erro', 'Nenhuma URL disponível para copiar.')
        return
      }

      navigator.clipboard.writeText(texto)
        .then(() => {
          util.criarAlertaToastDeSucesso(this, 'Sucesso', 'URL copiada com sucesso.')
        })
        .catch(err => {
          console.error('Erro ao copiar: ', err)
          util.criarAlertaToastDeErro(this, 'Erro', 'Falha ao copiar a URL.')
        })
    }
  }
}
